module.exports = __webpack_public_path__ + "assets/ic_tree21.f8ee0bb1.svg";